import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { holidaySchema } from "./schema";
import { fetchHolidayData } from "./read";
import { useUpdateHoliday } from "../update/mutation";
import { useCreateHoliday } from "../create/mutation";

export const useHolidayForm = ({ holidayId }) => {
  const form = useForm({
    resolver: zodResolver(holidaySchema),
    defaultValues: {
      date: "",
      name: "",
    },
  });

  const updateHoliday = useUpdateHoliday();
  const createHoliday = useCreateHoliday();

  const handleCreate = async (context) => {
    const item = context.values;
    await createHoliday.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateHoliday.mutateAsync({ holidayId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchHolidayData({ holidayId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
